import React, { useState } from 'react';
import { Field, FormSpy } from 'react-final-form';
import cn from '@/utils/cn';
import styles from '../../Form.module.scss';

interface SearchAndReplaceProps {
  searchForFieldName: 'staffer_username_search_for' | 'student_username_search_for';
  replaceWithFieldName: 'staffer_username_replace_with' | 'student_username_replace_with';
  searchFor: string;
  replaceWith: string;
  userType: 'student' | 'staffer';
}

const SearchAndReplace = ({
  searchFor, replaceWith, searchForFieldName, replaceWithFieldName, userType,
}: SearchAndReplaceProps) => {
  const [isChecked, setIsChecked] = useState(!!searchFor || !!replaceWith);

  return (
    <FormSpy>
      {({ form }) => (
        <div className="tw-flex tw-flex-col tw-ml-[90px] tw-mb-5">
          <div className="tw-flex tw-items-center tw-mb-2">
            <input
              checked={isChecked}
              id={`${userType}_search_and_replace`}
              type="checkbox"
              onChange={() => {
                setIsChecked((prev) => {
                  const checked = !prev;

                  // clear form state when unchecking
                  if (!checked) {
                    form.change(searchForFieldName, null);
                    form.change(replaceWithFieldName, null);
                  }

                  return !prev;
                });
              }}
            />
            <label htmlFor={`${userType}_search_and_replace`}>
              Modify with Replace
            </label>
          </div>

          {isChecked && (
            <div className="tw-flex">
              <div className="tw-flex tw-items-center tw-mr-2">
                <label className="tw-mr-2 tw-text-nowrap" htmlFor={searchForFieldName}>
                  Search For:
                </label>
                <Field
                  className={cn(styles.textInput, 'tw-w-auto')}
                  component="input"
                  id={searchForFieldName}
                  name={searchForFieldName}
                />
              </div>

              <div className="tw-flex tw-items-center">
                <label className="tw-mr-2 tw-text-nowrap" htmlFor={replaceWithFieldName}>
                  Replace With:
                </label>
                <Field
                  className={cn(styles.textInput, 'tw-w-auto')}
                  component="input"
                  id={replaceWithFieldName}
                  name={replaceWithFieldName}
                />
              </div>
            </div>
          )}
        </div>
      )}
    </FormSpy>
  );
};

export default SearchAndReplace;
